import { cn } from '@/lib/utils';
import type { HostStatus } from '@/types/home';

const COLOR: Record<HostStatus, string> = {
  ONLINE: 'bg-gp-online',
  AWAY: 'bg-amber-400',
  OFFLINE: 'bg-gp-ink-600/40',
};

/** 상태 점. 'Online' 글자는 ink 색으로 따로 쓴다 (초록 텍스트 금지). */
export default function OnlineDot({
  status,
  className,
}: {
  status: HostStatus;
  className?: string;
}) {
  return (
    <span
      className={cn(
        'inline-block size-2.5 rounded-full ring-2 ring-white',
        COLOR[status],
        className,
      )}
      aria-hidden="true"
    />
  );
}
